import axios from './axios'

export const createSubscription = ({ data }) => axios.post('subscription/create', data)
export const getSubscription = () => axios.get('subscription')
export const getInvoices = () => axios.get('subscription/invoices')
export const changeSubscription = ({ data }) => axios.post('subscription/change', data)
